var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.col.type !== 'row-title' && _vm.row.type == 'communication')?_c('div',{staticClass:"channel-radios"},[_vm._l((_vm.channels.filter(
      function (channel) { return channel.visible == true; }
    )),function(channel,id){return [_c('ChannelRadio',{key:("channel_radio_" + _vm.rowId + "_" + _vm.columnId + "_" + id),attrs:{"rowId":_vm.rowId,"columnId":_vm.columnId,"id":id}})]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }